let idCounter = 0

export function useId() {
    return `v-id-${++idCounter}`
}